
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogArticles/[blogArticleSlug]",
      function () {
        return require("private-next-pages/blogArticles/[blogArticleSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogArticles/[blogArticleSlug]"])
      });
    }
  